/** Realtime en maestros (catálogo/stock). Off por default — usar timer 15 min + focus. */
export function isRealtimeMastersEnabled(): boolean {
  const raw = process.env.EXPO_PUBLIC_REALTIME_MASTERS?.trim().toLowerCase();
  return raw === '1' || raw === 'true' || raw === 'yes';
}
